<style lang="stylus">
    ._dropdown-box
        .z-dropdown-selector
            right unset !important
        ._dropdown
            display flex
            align-items center
            justify-content space-between
            width 100%
            height 28px
            padding-left 8px
            padding-right 10px
            border 1px solid var(--border-color-gray2)
            border-radius 4px
            .down-arrow
                color var(--svg-color-primary)
            p
                textOverflow()
                color var(--text-color-primary)
</style>

<template>
    <Dropdownss class="_dropdown-box" :data="dataList" @selectData="clickList">
        <div class="_dropdown">
            <p :title="displayStr">{{ displayStr }}</p>
            <iconSymbol class="down-arrow" name="aiset-arrow" style="width: 8px; height: 8px"></iconSymbol>
        </div>
    </Dropdownss>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dropdownss from "@/home/parts/pcView/parts/Dropdown.vue";

    @Component({
        components: {
            Dropdownss,
        },
    })
    export default class Dropdowns extends Vue {
        @Prop()
        dataList;
        @Prop()
        value;

        get displayStr() {
            return this.dataList[this.value] ? this.dataList[this.value].label : "";
        }

        clickList(e) {
            this.$emit("input", e);
            this.$emit("selectData", this.dataList[this.value].value);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
